/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { organisationGetOrganisationList } from '../fn/organisation/organisation-get-organisation-list';
import { OrganisationGetOrganisationList$Params } from '../fn/organisation/organisation-get-organisation-list';
import { OrganisationList } from '../models/organisation-list';

@Injectable({ providedIn: 'root' })
export class OrganisationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `organisationGetOrganisationList()` */
  static readonly OrganisationGetOrganisationListPath = '/organisation/list';

  /**
   * Get organisations for the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organisationGetOrganisationList()` instead.
   *
   * This method doesn't expect any request body.
   */
  organisationGetOrganisationList$Response(params?: OrganisationGetOrganisationList$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganisationList>> {
    const obs = organisationGetOrganisationList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get organisations for the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organisationGetOrganisationList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organisationGetOrganisationList(params?: OrganisationGetOrganisationList$Params, context?: HttpContext): Observable<OrganisationList> {
    const resp = this.organisationGetOrganisationList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrganisationList>): OrganisationList => r.body)
    );
  }

}
